export const messengerCardSpec = {
  content: '',
  group: 'block',
  marks: '',
  atom: true,
  attrs: {
    type: {
      default: 'messengerCard'
    },
    canvas: {},
    text: {
      default: ''
    },
    messenger_app_id: {
      default: ''
    },
    uri: {
      default: ''
    }
  },
  toDOM() {
    return ['div'];
  }
};